module.exports = __webpack_public_path__ + "img/section8-1-index.137dbdbe.jpg";